import {Quiz} from '@/services/Quiz'
import {getCurrentQuiz, getRandomPastQuiz} from '@/services/BrApiAdapter'

export default {
  async initCurrentQuiz() {
    let quizResponse = await getCurrentQuiz()
    this.quizState = new Quiz(quizResponse.quiz_data)
    return this.quizState
  },
  async initRandomPastQuiz() {
    let quizResponse = await getRandomPastQuiz()
    this.quizState = new Quiz(quizResponse.quiz_data)
    return this.quizState
  },
  quizState: {} as Quiz
}